import { createThunk, model } from 'mst-collection';
import { castToSnapshot, types } from 'mobx-state-tree';

import { TutorialModel } from './TutorialModel';
import { Api, schemas } from '@api';
import {
  ExtendedListModel,
  handleFlow,
  shouldRejectPagination,
} from '../utils';

export class GenericTutorialList extends ExtendedListModel(
  types.reference(TutorialModel),
  {
    type: types.string,
    id: types.maybe(types.number),
  },
  {
    idAttribute: 'id',
    schema: schemas.TutorialListSchema,
    pageSize: 30,
  },
) {
  private get _path() {
    if (typeof this.id === 'number') {
      return `${this.type}/${this.id}`;
    }

    return this.type;
  }

  fetch = createThunk(() => {
    return async function fetch(this: GenericTutorialList) {
      const res = await Api.Hub.getGenericTutorials({
        count: this.pageSize,
        start: 0,
        path: this._path,
      });

      this.set(res.data.videos);
    };
  });

  fetchMore = createThunk(() => {
    return async function fetchMore(this: GenericTutorialList, flow) {
      if (shouldRejectPagination(this)) {
        return;
      }

      await handleFlow(flow, async () => {
        const res = await Api.Hub.getGenericTutorials({
          count: this.pageSize,
          start: this.offset,
          path: this._path,
        });

        this.append(castToSnapshot(res.data.videos));
      });
    };
  }, false);
}

export const GenericTutorialListModel = model(GenericTutorialList);
